import { CircularProgress as CircularProgressIcon } from '@mui/material';
import { colors } from '../../const';

interface LoadingIconProps {
  color?: keyof typeof colors;
}

export const LoadingIcon = ({ color }: LoadingIconProps) => {
  return (
    <CircularProgressIcon
      size={24}
      sx={{
        position: 'absolute',
        right: 10,
        color: color ? colors[color] : undefined,
      }}
    />
  );
};
